export var DEFAULT_FILE_TYPES = {
  files: ['text/plain', 'application/json'],
  images: ['image/*'],
  pkcs12: ['application/x-pkcs12'],
  pkcs8: ['application/pkcs8']
};
export var DEFAULT_IMAGE_DIMENSIONS = {
  notificationIcon: [512, 512],
  notificationBadge: [72, 72]
};